import { onClickAll } from './htmlListeners.js';
import { redirectToPage } from './page-routes.js';

(function initCheckbox() {
  onClickAll('.checkbox', (event) => {
    if (!(event.target.nodeName === 'A')) {
      event.currentTarget.classList.toggle('checkbox_checked');
    }
  });
})();

(function initBackBtn() {
  onClickAll('.behavior-go-back', () => {
    globalThis.history.go(-1);
  });
})();

(function initBtnGoHome() {
  onClickAll('.behavior-go-home', () => {
    globalThis.location.href = localStorage.getItem('home');
  });
})();

(function initBtnGoToCombos() {
  onClickAll('.behavior-go-combos', () => {
    redirectToPage.combos();
  });
})();
